import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowRight, BookOpen, CalendarDays, Clock, PlusCircle, Sparkles, Star } from 'lucide-react';
import { useDatos } from '../contexts/DatosContext';
import { Tarjeta } from '../components/ui/Tarjeta';
import { Boton } from '../components/ui/Boton';
import { Insignia } from '../components/ui/Etiquetas';
import { formatearFecha, formatearFechaHora } from '../utils/clase';
export function Inicio() {
  const {
    clases,
    favoritos,
    borrador
  } = useDatos();
  const navegar = useNavigate();
  const ultimaModificacion = clases.reduce<string | null>((acc, c) => {
    if (!acc) return c.modificadoEn;
    return new Date(c.modificadoEn) > new Date(acc) ? c.modificadoEn : acc;
  }, null);
  const proximosObjetivos = clases.filter(c => c.evaluacion && c.evaluacion.proximoObjetivo.trim()).sort((a, b) => new Date(b.modificadoEn).getTime() - new Date(a.modificadoEn).getTime()).slice(0, 4);
  const recientes = [...clases].sort((a, b) => new Date(b.modificadoEn).getTime() - new Date(a.modificadoEn).getTime()).slice(0, 3);
  return <div className="space-y-6" data-id="element-613" data-mp="232244yupm9ao">
      <section className="rounded-2xl bg-vino-oscuro p-6 text-white sm:p-8" data-id="element-614" data-mp="230zgr0wliozi">
        <p className="text-xs font-semibold uppercase tracking-wide text-white/60" data-id="element-615" data-mp="1y40oknwhss3y">
          Planificador Pro de Clases de Telas
        </p>
        <h1 className="mt-2 text-2xl font-extrabold sm:text-3xl" data-id="element-616" data-mp="1tzsvyfmwys0g">
          Tu próxima clase, clara y lista para usar
        </h1>
        <p className="mt-3 max-w-2xl text-sm text-white/80" data-id="element-617" data-mp="2lsa79gyeszqv">
          Organizá objetivos, tiempos, ejercicios y adaptaciones. Todo queda guardado en este
          dispositivo.
        </p>
        <div className="mt-6 flex flex-col gap-3 sm:flex-row" data-id="element-618" data-mp="2csdkxlzhscyz">
          <Boton onClick={() => navegar('/nueva')} data-id="element-619" data-mp="2cu7xod0m0yrz">
            <PlusCircle className="h-4 w-4" aria-hidden="true" data-id="element-620" data-mp="16cbbz69w4y81" />
            Crear nueva clase
          </Boton>
          {borrador && <Boton variante="contorno" className="border-white/30 bg-white/10 text-white hover:border-white hover:bg-white/20" onClick={() => navegar('/nueva')} data-id="element-621" data-mp="11bncrxbidb2q">
              Continuar borrador
              {borrador.titulo ? `: ${borrador.titulo}` : ''}
            </Boton>}
        </div>
      </section>

      <section aria-label="Resumen" data-id="element-622" data-mp="xtzjdyau26s3">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3" data-id="element-623" data-mp="xx3xbne3ogvy">
          <Tarjeta data-id="element-624" data-mp="k2uiksvqb8g6">
            <div className="flex items-center gap-2 text-tinta-tenue" data-id="element-625" data-mp="k2bcqajcsaii">
              <CalendarDays className="h-4 w-4" aria-hidden="true" data-id="element-626" data-mp="ove4qe8hfbwl" />
              <span className="text-xs font-semibold uppercase tracking-wide" data-id="element-627" data-mp="a5q2nash897t">Clases guardadas</span>
            </div>
            <p className="mt-2 text-3xl font-extrabold text-tinta-titulo" data-id="element-628" data-mp="f3rqsa4reyq5">{clases.length}</p>
          </Tarjeta>
          <Tarjeta data-id="element-629" data-mp="1632stfebbgv">
            <div className="flex items-center gap-2 text-tinta-tenue" data-id="element-630" data-mp="15jve6ndg5h3">
              <Star className="h-4 w-4" aria-hidden="true" data-id="element-631" data-mp="62tivgr7a72a" />
              <span className="text-xs font-semibold uppercase tracking-wide" data-id="element-632" data-mp="3infqy884bnm2">Favoritos</span>
            </div>
            <p className="mt-2 text-3xl font-extrabold text-tinta-titulo" data-id="element-633" data-mp="3domcodl0bsku">{favoritos.length}</p>
          </Tarjeta>
          <Tarjeta data-id="element-634" data-mp="3rodu6oaqfr3l">
            <div className="flex items-center gap-2 text-tinta-tenue" data-id="element-635" data-mp="3rox1lb2rax3d">
              <Clock className="h-4 w-4" aria-hidden="true" data-id="element-636" data-mp="3nmahxxg8oih9" />
              <span className="text-xs font-semibold uppercase tracking-wide" data-id="element-637" data-mp="3nowp3vz7wvyy">
                Última modificación
              </span>
            </div>
            <p className="mt-2 text-lg font-bold text-tinta-titulo" data-id="element-638" data-mp="gt1oltdkgel">
              {ultimaModificacion ? formatearFechaHora(ultimaModificacion) : 'Sin registros'}
            </p>
          </Tarjeta>
        </div>
      </section>

      <section aria-label="Accesos rápidos" data-id="element-639" data-mp="a8fgst8u2zmm">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-3" data-id="element-640" data-mp="o6vnik6p4q4r">
          <AccesoRapido a="/clases" titulo="Mis clases" texto="Buscar, filtrar, duplicar e imprimir." icono={<CalendarDays className="h-5 w-5 text-vino" aria-hidden="true" data-id="element-642" data-mp="2dpc120puigs8" />} data-id="element-641" data-mp="o5c44kpqtyyr" />
          <AccesoRapido a="/biblioteca" titulo="Explorar biblioteca" texto="64 recursos base con prerrequisitos y seguridad." icono={<BookOpen className="h-5 w-5 text-vino" aria-hidden="true" data-id="element-644" data-mp="2ngpz0425f8j9" />} data-id="element-643" data-mp="2in3rsrer7wuu" />
          <AccesoRapido a="/personalizados" titulo="Crear ejercicio propio" texto="Sumá tu contenido y tus copias personalizadas." icono={<Sparkles className="h-5 w-5 text-vino" aria-hidden="true" data-id="element-646" data-mp="1zpkkptbuwob2" />} data-id="element-645" data-mp="2ri1p0aoxpvrz" />
        </div>
      </section>

      <section aria-label="Próximos objetivos" data-id="element-647" data-mp="23p1n2dvzl5c0">
        <Tarjeta data-id="element-648" data-mp="28pz58qgzxzdi">
          <h2 className="text-lg font-bold text-tinta-titulo" data-id="element-649" data-mp="28qims62qilr0">Próximos objetivos</h2>
          <p className="mt-1 text-sm text-tinta-sec" data-id="element-650" data-mp="3f61ihidms0a9">
            Tomados de las evaluaciones que completaste después de cada clase.
          </p>
          {proximosObjetivos.length === 0 ? <p className="mt-4 rounded-xl border border-linea bg-lienzo p-4 text-sm text-tinta-sec" data-id="element-651" data-mp="3u92t3vnlf8v4">
              Todavía no cargaste evaluaciones con un próximo objetivo. Marcá una clase como
              realizada para registrarlo.
            </p> : <ul className="mt-4 space-y-3" data-id="element-652" data-mp="3kgdn3gatan76">
              {proximosObjetivos.map(c => <li key={c.id} className="rounded-xl border border-linea p-3" data-id="element-653" data-mp="3gf21rmyz0o4s">
                  <div className="flex flex-wrap items-center gap-2" data-id="element-654" data-mp="3bjmpv0kix2b0">
                    <Insignia tono="vino" data-id="element-655" data-mp="36hxgdpcy8wp1">{c.nivel}</Insignia>
                    <span className="text-sm font-semibold text-tinta-titulo" data-id="element-656" data-mp="31jvz99z337g7">{c.titulo}</span>
                    <span className="text-xs text-tinta-tenue" data-id="element-657" data-mp="2xiad0y0ntgtc">{formatearFecha(c.fecha)}</span>
                  </div>
                  <p className="mt-2 text-sm text-tinta-sec" data-id="element-658" data-mp="zs96b2vmt2h3">{c.evaluacion?.proximoObjetivo}</p>
                </li>)}
            </ul>}
        </Tarjeta>
      </section>

      <section aria-label="Clases recientes" data-id="element-659" data-mp="2p9wk42e8p3vx">
        <Tarjeta data-id="element-660" data-mp="2p83aqfc8s5k8">
          <h2 className="text-lg font-bold text-tinta-titulo" data-id="element-661" data-mp="2p7jrmvauvb4m">Clases recientes</h2>
          {clases.length === 0 ? <p className="mt-3 rounded-xl border border-linea bg-lienzo p-4 text-sm text-tinta-sec" data-id="element-662" data-mp="2g8yddccf2i9n">
              Todavía no guardaste ninguna clase. Creá la primera y usala como base para las
              próximas.
            </p> : <ul className="mt-3 divide-y divide-linea" data-id="element-663" data-mp="381fly5wj2bwd">
              {recientes.map(c => <li key={c.id} className="flex flex-wrap items-center justify-between gap-3 py-3" data-id="element-664" data-mp="3cxxmetktro2w">
                  <div data-id="element-665" data-mp="2yyo5tsspirye">
                    <p className="text-sm font-semibold text-tinta-titulo" data-id="element-666" data-mp="2yz6ddlktkslm">{c.titulo || 'Sin título'}</p>
                    <p className="text-xs text-tinta-tenue" data-id="element-667" data-mp="340nbj9bx60yi">
                      {formatearFecha(c.fecha)} · {c.nivel} · {c.duracion} min · {c.estado}
                    </p>
                  </div>
                  <Link to={`/nueva/${c.id}`} className="inline-flex min-h-[44px] items-center gap-1 rounded-xl px-3 text-sm font-semibold text-vino hover:bg-vino/5" data-id="element-668" data-mp="1shau9glecbhx">
                    Abrir
                    <ArrowRight className="h-4 w-4" aria-hidden="true" data-id="element-669" data-mp="1u0suriq4b0ie" />
                  </Link>
                </li>)}
            </ul>}
        </Tarjeta>
      </section>
    </div>;
}
function AccesoRapido({
  a,
  titulo,
  texto,
  icono
}: {
  a: string;
  titulo: string;
  texto: string;
  icono: React.ReactNode;
}) {
  return <Link to={a} className="flex items-start gap-3 rounded-2xl border border-linea bg-white p-4 transition-colors hover:border-vino/40" data-id="element-670" data-mp="way0jkrhp5wl">
      <span className="mt-0.5 shrink-0" data-id="element-671" data-mp="16a6pfz7hzuc3">{icono}</span>
      <span data-id="element-672" data-mp="ile04lldskqg">
        <span className="block text-sm font-bold text-tinta-titulo" data-id="element-673" data-mp="ikuiz73k20dh">{titulo}</span>
        <span className="mt-1 block text-sm text-tinta-sec" data-id="element-674" data-mp="dmatwxto08gw">{texto}</span>
      </span>
    </Link>;
}